export const SET_FORMS = "SET_FORMS";
export const TOGGLE_FORM = "TOGGLE_FORM";

export const CLEAR_FORM_LIST_RESPONSES = "CLEAR_FORM_LIST_RESPONSES";
export const SET_FORM_LIST_RESPONSES = "SET_FORM_LIST_RESPONSES";
export const SET_FORMS_LIST = "SET_FORMS_LIST";
export const TOGGLE_FORM_LIST = "TOGGLE_FORM_LIST";
export const TOGGLE_FORM_LIST_RESPONSE = "TOGGLE_FORM_LIST_RESPONSE";
